module.exports = __webpack_public_path__ + "img/Location.0c9f6578.svg";